"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[812,9366,2054,5622,5462,1267,136,9901,8315,3406,794,7480,3794],{

/***/ 70794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bloomreachAddToCartEvent": function() { return /* binding */ bloomreachAddToCartEvent; },
/* harmony export */   "bloomreachCategoryPagePixel": function() { return /* binding */ bloomreachCategoryPagePixel; },
/* harmony export */   "bloomreachContentPageViewPixel": function() { return /* binding */ bloomreachContentPageViewPixel; },
/* harmony export */   "bloomreachConversionEvent": function() { return /* binding */ bloomreachConversionEvent; },
/* harmony export */   "bloomreachHomePagePixel": function() { return /* binding */ bloomreachHomePagePixel; },
/* harmony export */   "bloomreachOtherPagePixel": function() { return /* binding */ bloomreachOtherPagePixel; },
/* harmony export */   "bloomreachPageViewPixel": function() { return /* binding */ bloomreachPageViewPixel; },
/* harmony export */   "bloomreachSearchEvent": function() { return /* binding */ bloomreachSearchEvent; },
/* harmony export */   "bloomreachSearchPagePixel": function() { return /* binding */ bloomreachSearchPagePixel; },
/* harmony export */   "bloomreachSuggestEventPixel": function() { return /* binding */ bloomreachSuggestEventPixel; },
/* harmony export */   "sendDataToBloomreach": function() { return /* binding */ sendDataToBloomreach; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10304);
/* harmony import */ var _helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55622);









var generateBloomreachBaseScript = function(customScript) {
    var baseScript = "\n    var brtrk = document.createElement('script');\n    brtrk.type = 'text/javascript';\n    brtrk.async = true;\n    brtrk.src = \"//cdn.brcdn.com/v1/br-trk-".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.BLOOMREACH_ACCOUNT_ID, ".js\";\n    var s = document.getElementsByTagName('script')[0];\n    s.parentNode.insertBefore(brtrk, s);\n    var br_data = br_data || {};\n    br_data.acct_id = ").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.BLOOMREACH_ACCOUNT_ID, ";\n    br_data.test_data = '").concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_2__.IS_BLOOMREACH_TEST_ENV, "';\n  ");
    return customScript ? "".concat(baseScript, " ").concat(customScript) : baseScript;
};
var bloomreachConversionEvent = function(customerId, orderId, orderTotal, lineItems) {
    var updatedLineItems = lineItems.filter(_helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_4__/* .isNotShippingProtection */ .Y).map(function(_param) {
        var prod_id = _param.sku, sku = _param.sku, price = _param.subtotalPrice, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
            "sku",
            "sku",
            "subtotalPrice"
        ]);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            prod_id: prod_id,
            sku: sku,
            price: price
        }, rest);
    });
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    var scriptContent = "\n      ".concat(generateBloomreachBaseScript(), "\n      br_data.ptype = 'conversion';\n  ");
    if (customerId !== undefined && customerId !== 0) {
        scriptContent += "br_data.user_id = ".concat(customerId, ";");
    }
    scriptContent += "\n      br_data.is_conversion = ".concat(1, ";\n      br_data.basket_value = ").concat(orderTotal, ";\n      br_data.order_id = ").concat(orderId, ";\n      br_data.basket = {\n          'items': ").concat(JSON.stringify(updatedLineItems), ",\n      };\n  ");
    bloomreachScript.textContent = scriptContent;
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchPagePixel = function(title, userId) {
    var ref;
    var escapedTitle = (0,_helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__.escapeQuotes)(title);
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.setAttribute("id", "SearchPageViewPixel");
    bloomreachScript === null || bloomreachScript === void 0 ? void 0 : (ref = bloomreachScript.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(bloomreachScript);
    bloomreachScript.textContent = "\n        ".concat(generateBloomreachBaseScript(), '\n        br_data.ptype = "search";\n        ').concat(userId !== undefined && userId !== 0 ? "br_data.user_id = '".concat(String(userId), "';") : "", '\n        br_data.search_term = "').concat(escapedTitle, '"; \n      ');
    document.body.appendChild(bloomreachScript);
};
var bloomreachSearchEvent = function(searchString, userId) {
    if (window.BrTrk) {
        var ref, ref1;
        var searchData = {
            q: "",
            catalogs: [],
            user_id: 0
        };
        searchData.q = searchString;
        if (userId !== undefined && userId !== 0) {
            searchData.user_id = userId;
        }
        searchData.catalogs = [
            {
                "name": "onekingslane"
            }
        ];
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "submit", searchData, {}, true);
    }
};
var bloomreachAddToCartEvent = function(sku, productId) {
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("cart", "click-add", {
            "prod_id": productId,
            "sku": sku
        });
    }
};
var bloomreachPageViewPixel = function(product, customerId, sku) {
    if (!product) {
        return;
    }
    var prodId = product.sku.slice(1);
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("id", "PDPPixelScript");
    bloomreachScript.textContent = "\n      if (document.referrer !== document.location.href) {\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "product";\n          br_data.prod_name = \'').concat(product === null || product === void 0 ? void 0 : product.name.replace(/'/g, "\\'"), "';\n          br_data.prod_id = '").concat(prodId, "';\n          br_data.sku = '").concat(String(sku), "';\n  ");
    if (customerId !== undefined && customerId !== 0) {
        bloomreachScript.textContent += "br_data.user_id = '".concat(customerId, "';");
    }
    bloomreachScript.textContent += "\n  }\n  ";
    var script = document.getElementById("PDPPixelScript");
    if (script === null) {
        document.body.appendChild(bloomreachScript);
    }
};
var bloomreachContentPageViewPixel = function(pageTitle) {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.textContent = "\n          ".concat(generateBloomreachBaseScript(), "\n          br_data.catalogs = [ { name : 'onekingslane_discovery' } ];\n          br_data.item_name = '").concat(String(pageTitle), '\';\n          br_data.ptype = "content";\n        ');
    document.body.appendChild(bloomreachScript);
};
var bloomreachSuggestEventPixel = function(searchString, searchSuggestion, userId) {
    var searchData = {
        q: "",
        aq: "",
        catalogs: []
    };
    searchData.q = searchSuggestion;
    searchData.aq = searchString;
    searchData.catalogs = [
        {
            "name": "onekingslane"
        }
    ];
    if (userId !== undefined && userId !== 0) {
        searchData.user_id = userId;
    }
    if (window.BrTrk) {
        var ref, ref1;
        (ref = window.BrTrk) === null || ref === void 0 ? void 0 : (ref1 = ref.getTracker) === null || ref1 === void 0 ? void 0 : ref1.call(ref).logEvent("suggest", "click", searchData, {}, true);
    }
};
var geBreadCrumbId = function(breadcrumbs) {
    var ref;
    var id = (ref = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.slice(-1)[0]) === null || ref === void 0 ? void 0 : ref.id;
    // if its only numberic return as number otherwise return between quotes
    return /^\d+$/.test(String(id)) ? id : "'".concat(id, "'");
};
var bloomreachCategoryPagePixel = function(breadcrumbs) {
    if (!breadcrumbs || (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) === 0) {
        return;
    }
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "category";\n          br_data.cat_id = ').concat(geBreadCrumbId(breadcrumbs), ";\n          br_data.cat = '").concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(obj) {
        return (0,_helpers_getQueryWithValidCharacters__WEBPACK_IMPORTED_MODULE_3__.escapeQuotes)(obj.name);
    }).join("|"), "';\n  }");
    document.body.appendChild(bloomreachScript);
};
var bloomreachHomePagePixel = function() {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n  if (document.referrer !== document.location.href){\n        ".concat(generateBloomreachBaseScript(), '\n          br_data.ptype = "homepage";  }');
    document.body.appendChild(bloomreachScript);
};
var bloomreachOtherPagePixel = function() {
    var bloomreachScript = document.createElement("script");
    bloomreachScript.setAttribute("type", "text/javascript");
    bloomreachScript.textContent = "\n        ".concat(generateBloomreachBaseScript(), '\n        br_data.ptype = "other";\n        ');
    document.body.appendChild(bloomreachScript);
};
var sendDataToBloomreach = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventType, query, name) {
        var ref, getCustomer, customer;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    getCustomer = ref[0].getCustomer;
                    _ctx.next = 8;
                    return getCustomer();
                case 8:
                    customer = _ctx.sent.customer;
                    if (eventType === "SearchPage") {
                        bloomreachSearchPagePixel(query, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    } else if (eventType === "SuggestEvent") {
                        bloomreachSuggestEventPixel(query, name, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    } else {
                        bloomreachSearchEvent(query, customer === null || customer === void 0 ? void 0 : customer.entityId);
                    }
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendDataToBloomreach(eventType, query, name) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 51250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ EXTEND_SKU; }
/* harmony export */ });
var EXTEND_SKU = ";xtd;";


/***/ }),

/***/ 49125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SHIPPED_SHIELD_SKU; }
/* harmony export */ });
var SHIPPED_SHIELD_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 68533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ WORRY_FREE_DELIVERY_SKU; }
/* harmony export */ });
var WORRY_FREE_DELIVERY_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 40136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsExtendItem": function() { return /* binding */ checkIsExtendItem; }
/* harmony export */ });
/* harmony import */ var _data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51250);

var checkIsExtendItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_0__/* .EXTEND_SKU */ .J);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsExtendItem);


/***/ }),

/***/ 23406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsShippedShieldItem": function() { return /* binding */ checkIsShippedShieldItem; },
/* harmony export */   "hasShippedShieldItem": function() { return /* binding */ hasShippedShieldItem; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var checkIsShippedShieldItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || "".concat(variant.sku).includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsShippedShieldItem);
var hasShippedShieldItem = function(variants) {
    return variants.some(checkIsShippedShieldItem);
};


/***/ }),

/***/ 32054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_CHECKOUT_VARIANT": function() { return /* binding */ DEFAULT_CHECKOUT_VARIANT; },
/* harmony export */   "checkVariantNameIsSize": function() { return /* binding */ checkVariantNameIsSize; },
/* harmony export */   "formatPrice": function() { return /* binding */ formatPrice; },
/* harmony export */   "formatPriceRange": function() { return /* binding */ formatPriceRange; },
/* harmony export */   "formatPriceValue": function() { return /* binding */ formatPriceValue; },
/* harmony export */   "getCookieByName": function() { return /* binding */ getCookieByName; },
/* harmony export */   "getCustomerDetails": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "getCustomerOrderCount": function() { return /* binding */ getCustomerOrderCount; },
/* harmony export */   "getPriceOrPriceRange": function() { return /* binding */ getPriceOrPriceRange; },
/* harmony export */   "getWindowAgent": function() { return /* binding */ getWindowAgent; },
/* harmony export */   "priceValue": function() { return /* binding */ priceValue; },
/* harmony export */   "productClickGa": function() { return /* binding */ productClickGa; },
/* harmony export */   "productUpdateGA": function() { return /* binding */ productUpdateGA; },
/* harmony export */   "removeSpecialChars": function() { return /* binding */ removeSpecialChars; },
/* harmony export */   "sizeArray": function() { return /* binding */ sizeArray; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48080);






var getCustomerDetails = function() {
    try {
        var customerDetails = localStorage.getItem("customer");
        if (customerDetails) {
            var ref = JSON.parse(customerDetails), customerId = ref.customerId, customerEmail = ref.customerEmail;
            if ((typeof customerId === "number" || typeof customerId === "string") && typeof customerEmail === "string") {
                return {
                    customerId: customerId,
                    customerEmail: customerEmail
                };
            }
        }
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to get customer details from localStorage");
    }
    return {
        customerId: 0,
        customerEmail: ""
    };
};
var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var productClickGa = function(param) {
    var product = param.product, position = param.position, category = param.category;
    var sendToGA = function() {
        if (true) {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            // Define the event object with the correct structure.
            var eventData = {
                event: "productClick",
                ecommerce: {
                    visitorType: visitorType,
                    customerId: customerId,
                    click: {
                        actionField: {
                            list: kebabCase(category)
                        },
                        products: [
                            {
                                name: product.name,
                                id: product.variants[0].sku,
                                price: product.calculated_price,
                                brand: product.brand || "",
                                category: category,
                                variant: product.variants[0].id,
                                position: position
                            }
                        ]
                    }
                },
                customerEmail: customerEmail
            };
            // Push event data to the dataLayer with type safety.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var productUpdateGA = function(lineItem, event, cartTotal) {
    var sendToGA = function() {
        try {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            var keyName = event === "addToCart" ? "add" : "remove";
            var _obj;
            // Create the correct GA event based on the input event type.
            var eventData = {
                event: event,
                ecommerce: (_obj = {
                    visitorType: visitorType,
                    customerId: customerId
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, keyName, {
                    products: [
                        {
                            name: lineItem.name,
                            // for grouped products like quilts, do you have a default that you can use?
                            id: lineItem.sku,
                            // for grouped products like quilts, do you have a default that you can use?
                            price: lineItem.originalPrice,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: lineItem.salePrice,
                            brand: lineItem.brand,
                            variant: lineItem.variantId,
                            quantity: lineItem.quantity
                        }
                    ]
                }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "customerEmail", customerEmail), _obj),
                cartTotal: cartTotal
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to send GA event", err);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var getCustomerOrderCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var orderCountFromStorage, ref, getCustomer, getCustomerOrders, ref1, customer, success, orderCount;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    orderCountFromStorage = sessionStorage.getItem("customerOrderCount");
                    if (!(orderCountFromStorage !== null && orderCountFromStorage)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", parseInt(orderCountFromStorage));
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)),
                            __webpack_require__.e(/* import() */ 1950).then(__webpack_require__.bind(__webpack_require__, 41950)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    getCustomer = ref[0].getCustomer;
                    getCustomerOrders = ref[1].getCustomerOrders;
                    _ctx.next = 12;
                    return getCustomer();
                case 12:
                    ref1 = _ctx.sent;
                    customer = ref1.customer;
                    success = ref1.success;
                    if (!(!success || !customer)) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 17:
                    _ctx.next = 19;
                    return getCustomerOrders({
                        sort: "date_created:desc"
                    });
                case 19:
                    orderCount = _ctx.sent.length;
                    sessionStorage.setItem("customerOrderCount", "".concat(orderCount));
                    return _ctx.abrupt("return", orderCount);
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCustomerOrderCount() {
        return _ref.apply(this, arguments);
    };
}();
var formatPrice = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // using parseFloat to make sure this function works for both number and string
    var floatPrice = parseFloat("".concat(price || ""));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return "$".concat(parseFloat("".concat(price || "")).toFixed(digit));
};
var formatPriceValue = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var floatPrice = parseFloat(String(price));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return Number(parseFloat(String(price)).toFixed(digit));
};
// using parseFloat to make sure this function works for both number and string
var formatPriceRange = function(minPrice, maxPrice) {
    var digit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return "".concat(formatPrice(minPrice, digit) || "", " - ").concat(formatPrice(maxPrice, digit) || "");
};
var getPriceOrPriceRange = function(product, priceType) {
    var ref;
    var variants = product.variants;
    var sortedVariantPrices = (ref = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        return parseFloat("".concat(variant[priceType]));
    })) === null || ref === void 0 ? void 0 : ref.sort();
    var minPrice = variants ? sortedVariantPrices[0] : product[priceType];
    var maxPrice = variants ? sortedVariantPrices.pop() : product[priceType];
    return minPrice === maxPrice ? formatPrice(minPrice) : formatPriceRange(minPrice, maxPrice);
};
var sizeArray = [
    "small",
    "medium",
    "large",
    "extra small",
    "extra large",
    "long",
    "tall",
    "short"
];
var checkVariantNameIsSize = function(el) {
    var name = el.option_values[0].label.toLowerCase();
    if (/^\d/.test(name) || sizeArray.includes(name)) {
        return true;
    }
    return false;
};
var priceValue = function(price) {
    return price.split("$")[1];
};
var removeSpecialChars = function(string) {
    var regex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /[^a-zA-Z \s0-9,'\-#.*&]/g;
    return "".concat(string).replace(regex, "");
};
var getCookieByName = function(name, cookiesFromRequest) {
    var cookies;
    if (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
        var _cookie;
        cookies = (_cookie = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document.cookie) !== null && _cookie !== void 0 ? _cookie : "";
    } else {
        cookies = cookiesFromRequest !== null && cookiesFromRequest !== void 0 ? cookiesFromRequest : "";
    }
    if (cookies) {
        var ref, ref1;
        var ref2;
        var cookieName = (ref2 = (ref = cookies.split(";")) === null || ref === void 0 ? void 0 : ref.find(function(cookie) {
            return cookie.includes(name);
        })) !== null && ref2 !== void 0 ? ref2 : "";
        return (ref1 = cookieName === null || cookieName === void 0 ? void 0 : cookieName.split("=")) === null || ref1 === void 0 ? void 0 : ref1[1];
    }
    return "";
};
// IDs for each variant within an experiment are numeric and indexed at 0
var DEFAULT_CHECKOUT_VARIANT = "0";
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getWindowAgent = function(nextContextReq) {
    // Ref: https://stackoverflow.com/questions/59494037/how-to-detect-the-device-on-react-ssr-app-with-next-js
    // if you are on the server and you get a 'nextContextReq' property from your context
    if (nextContextReq) {
        // get the user-agent from the headers
        return nextContextReq.headers["user-agent"];
    }
    // if you are on the client you can access the navigator from the window object
    return navigator.userAgent;
};


/***/ }),

/***/ 48315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "customerGA": function() { return /* binding */ customerGA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _FP__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13174);






var fetchCustomerGAModules = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, getCustomer, getCustomerOrders;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)),
                            __webpack_require__.e(/* import() */ 9668).then(__webpack_require__.bind(__webpack_require__, 41950)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    getCustomer = ref[0].getCustomer;
                    getCustomerOrders = ref[1].getCustomerOrders;
                    return _ctx.abrupt("return", {
                        getCustomer: getCustomer,
                        getCustomerOrders: getCustomerOrders
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCustomerGAModules() {
        return _ref.apply(this, arguments);
    };
}();
var getIdAndEmail = function(maybeCustomer) {
    return {
        customerId: (maybeCustomer === null || maybeCustomer === void 0 ? void 0 : maybeCustomer.entityId) || 0,
        customerEmail: (maybeCustomer === null || maybeCustomer === void 0 ? void 0 : maybeCustomer.email) || ""
    };
};
var getOrdersCount = function(customerId) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var getCustomerOrders;
            return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getCustomerOrders = param.getCustomerOrders;
                        if (customerId) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.t0 = 0;
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.next = 7;
                        return getCustomerOrders({
                            sort: "date_created:desc"
                        });
                    case 7:
                        _ctx.t0 = _ctx.sent.length;
                    case 8:
                        return _ctx.abrupt("return", _ctx.t0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};
var sendToGAHappyPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var cartAmount, pageType, ref, ref1, getCustomer, getCustomerOrders, customer, ref2, customerId, customerEmail, orderCount;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cartAmount = param.cartAmount, pageType = param.pageType;
                    ;
                    _ctx.next = 4;
                    return fetchCustomerGAModules();
                case 4:
                    ref1 = _ctx.sent;
                    getCustomer = ref1.getCustomer;
                    getCustomerOrders = ref1.getCustomerOrders;
                    _ctx.next = 9;
                    return getCustomer();
                case 9:
                    customer = _ctx.sent.customer;
                    ref2 = getIdAndEmail(customer), customerId = ref2.customerId, customerEmail = ref2.customerEmail;
                    _ctx.next = 13;
                    return getOrdersCount(customerId)({
                        getCustomerOrders: getCustomerOrders
                    });
                case 13:
                    orderCount = _ctx.sent;
                    window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
                        event: "customer",
                        visitorType: customerId ? "Logged In" : "Guest",
                        customerId: customerId,
                        customerEmail: customerEmail,
                        customerOrdersCount: orderCount,
                        customerTotalSpent: "",
                        cartTotal: cartAmount,
                        pageType: pageType
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendToGAHappyPath(_) {
        return _ref.apply(this, arguments);
    };
}();
var logErrorWhileSendingCustomerGAEvent = function(err) {
    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to send customer to GA", err);
};
var sendToGA = (0,_FP__WEBPACK_IMPORTED_MODULE_3__/* .thenCaught */ .HA)(sendToGAHappyPath)(logErrorWhileSendingCustomerGAEvent);
var executeWhenLoadedAndInteractive = function(fn) {
    if (window.loadedAndInteractive) {
        fn();
    } else {
        window.addEventListener("loadedAndInteractive", function() {
            fn();
        }, {
            once: true
        });
    }
};
var customerGA = function(cartAmount, pageType) {
    return executeWhenLoadedAndInteractive(function() {
        return sendToGA({
            cartAmount: cartAmount,
            pageType: pageType
        });
    });
};


/***/ }),

/***/ 63548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": function() { return /* binding */ formatMoney; }
/* harmony export */ });
// formatMoney takes a numeric value and returns a printable string
// formatMoney(123456.78) => $123,456.78
var BLANK_MONEY_VALUE = "--";
var formatMoney = function(value) {
    return typeof value === "number" ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
    }).format(parseFloat("".concat(value || "0"))) : BLANK_MONEY_VALUE;
};
/* harmony default export */ __webpack_exports__["default"] = (formatMoney);


/***/ }),

/***/ 55622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "escapeQuotes": function() { return /* binding */ escapeQuotes; },
/* harmony export */   "getQueryWithValidCharacters": function() { return /* binding */ getQueryWithValidCharacters; },
/* harmony export */   "getQueryXssEscaped": function() { return /* binding */ getQueryXssEscaped; },
/* harmony export */   "removeIllegalCharacters": function() { return /* binding */ removeIllegalCharacters; },
/* harmony export */   "xssEscape": function() { return /* binding */ xssEscape; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_0__);



var LEGAL_FILTER_CHARACTER_SET = /^[\w \-+,$'"&%’”./`]+$/;
var removeIllegalCharacters = function(s) {
    return s.replace(new RegExp("[^".concat(LEGAL_FILTER_CHARACTER_SET.source, "]"), "g"), "");
};
var getQueryWithValidCharacters = function(queryWithoutSlug) {
    var copied = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, queryWithoutSlug);
    var hasIllegalChar = function(str) {
        return !LEGAL_FILTER_CHARACTER_SET.test(str);
    };
    var deleteKey = function(key) {
        return delete copied[key];
    };
    Object.keys(copied).forEach(function(key) {
        var value = copied[key];
        if (!value) {
            deleteKey(key);
        } else if (Array.isArray(value)) {
            deleteKey(key);
        } else if (hasIllegalChar(value)) {
            deleteKey(key);
        }
    });
    return copied;
};
var xssEscape = function(s) {
    return xss__WEBPACK_IMPORTED_MODULE_0___default()(s);
};
var getQueryXssEscaped = function(query) {
    var escaped = Object.entries(query).reduce(function(hash, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], val = _param[1];
        if (val && !Array.isArray(val)) {
            // eslint-disable-next-line no-param-reassign
            hash[key] = xssEscape(val);
        }
        return hash;
    }, {});
    return escaped;
};
var escapeQuotes = function(s) {
    return s.replace('"', '\\"').replace("'", "\\'").replace("`", "\\`");
};
/* harmony default export */ __webpack_exports__["default"] = (getQueryWithValidCharacters);


/***/ }),

/***/ 10304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isShippingProtection; },
/* harmony export */   "Y": function() { return /* binding */ isNotShippingProtection; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var isShippingProtection = function(item) {
    return item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || item.sku.includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
var isNotShippingProtection = function(item) {
    return !isShippingProtection(item);
};


/***/ }),

/***/ 51105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hooks_PdpTrackingServices; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/GA4Events.tsx
var GA4Events = __webpack_require__(66778);
// EXTERNAL MODULE: ./helpers/customerGA.ts
var customerGA = __webpack_require__(48315);
// EXTERNAL MODULE: ./helpers/formatMoney.ts
var formatMoney = __webpack_require__(63548);
// EXTERNAL MODULE: ./hooks/useProduct/index.tsx + 5 modules
var useProduct = __webpack_require__(77690);
;// CONCATENATED MODULE: ./hooks/usePrevious.ts

var usePrevious = function(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./components/ScriptIntegrations/BloomreachEvents.tsx
var BloomreachEvents = __webpack_require__(70794);
// EXTERNAL MODULE: ./services/Listrak/listrakProductBrowse.ts
var listrakProductBrowse = __webpack_require__(65416);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
;// CONCATENATED MODULE: ./services/MarketingChannels.ts





var skuChangeReactor = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(name, category, variantId, price) {
        var // google ads
        ref, ref1, getCategoryName, categoryName;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    try {
                        ;
                        (ref = window.gtag) === null || ref === void 0 ? void 0 : ref.call(window, "event", "view_item", {
                            value: price,
                            items: [
                                {
                                    item_id: String(variantId),
                                    item_name: name,
                                    google_business_vertical: "retail"
                                }
                            ],
                            currency: "USD"
                        });
                    } catch (err) {
                        (0,Log/* error */.vU)("MarketingChannels error:", err);
                    }
                    _ctx.prev = 1;
                    if (!(typeof window.pintrk === "function")) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 6;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59126))
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref1 = (0, _ctx.t0)(_ctx.t1, 1);
                    getCategoryName = ref1[0].getCategoryName;
                    categoryName = getCategoryName(category);
                    window.pintrk("track", "pagevisit", {
                        line_items: [
                            {
                                product_id: variantId,
                                product_category: categoryName
                            }
                        ]
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t2 = _ctx["catch"](1);
                    (0,Log/* error */.vU)("MarketingChannels error", _ctx.t2);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }));
    return function skuChangeReactor(name, category, variantId, price) {
        return _ref.apply(this, arguments);
    };
}();
var onSkuChange = function(name, category, variantId, price) {
    setTimeout(function() {
        skuChangeReactor(name, category, variantId, price).catch(Log/* error */.vU);
    }, 500);
};
var MarketingChannels = {
    onSkuChange: onSkuChange
};
/* harmony default export */ var services_MarketingChannels = (MarketingChannels);

// EXTERNAL MODULE: ./services/Facebook.ts
var Facebook = __webpack_require__(11267);
;// CONCATENATED MODULE: ./hooks/PdpTrackingServices.tsx














var PdpTrackingServices = function(param) {
    var user = param.user, cart = param.cart, product = param.product;
    var ref = (0,useProduct.useProduct)(), sku = ref.sku, price = ref.price, fallBackPrice = ref.calculatedPrice, selectedVariantId = ref.variantId, selectedVariant = ref.selectedVariant;
    var variantPrice = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.calculated_price;
    var calculatedPrice = (0,formatMoney.formatMoney)(variantPrice) || fallBackPrice || "Not available";
    var previousSku = usePrevious(sku);
    (0,react.useEffect)(function() {
        if (sku && !previousSku) {
            (0,customerGA.customerGA)((cart === null || cart === void 0 ? void 0 : cart.total) || 0, "product");
        }
    }, [
        cart,
        sku,
        previousSku
    ]);
    (0,react.useEffect)(function() {
        (0,BloomreachEvents.bloomreachPageViewPixel)(product, user === null || user === void 0 ? void 0 : user.entityId, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku);
    }, [
        selectedVariant,
        product,
        user
    ]);
    var cartTotal = (0,react.useMemo)(function() {
        return (cart === null || cart === void 0 ? void 0 : cart.total) || 0;
    }, [
        cart
    ]);
    var quantity = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref1 = (ref = (0,_to_consumable_array/* default */.Z)((cart === null || cart === void 0 ? void 0 : cart.lineItems) || [])) === null || ref === void 0 ? void 0 : ref.find(function(i) {
            return (i === null || i === void 0 ? void 0 : i.sku) === sku;
        })) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0;
    }, [
        cart,
        sku
    ]);
    var customerId = user === null || user === void 0 ? void 0 : user.entityId;
    var customerEmail = user === null || user === void 0 ? void 0 : user.email;
    var salePrice = (0,react.useMemo)(function() {
        return parseFloat("".concat(calculatedPrice).replace(/(^\$|,)/g, ""));
    }, [
        calculatedPrice
    ]);
    var ref1 = (0,react.useState)(null), setDebouncer = ref1[1];
    (0,react.useEffect)(function() {
        if (!sku || !selectedVariantId || !product) {
            return;
        }
        setDebouncer(function(prev) {
            if (prev) {
                clearTimeout(prev);
            }
            return setTimeout(function() {
                setDebouncer(null);
                var v = {
                    name: product.name,
                    sku: sku,
                    price: price,
                    salePrice: salePrice,
                    variantId: selectedVariantId,
                    categories: product.category_info,
                    event: "productDetailView",
                    brand: product.brand || "",
                    quantity: quantity,
                    customerId: customerId,
                    customerEmail: customerEmail,
                    cartTotal: cartTotal
                };
                (0,Log/* log */.cM)("hooks/PdpTrackingServices.tsx", v);
                (0,GA4Events.productGA)(v);
                services_MarketingChannels.onSkuChange(product.name, product.category_info, selectedVariantId, salePrice);
                (0,listrakProductBrowse/* default */.Z)(sku);
            }, 1000);
        });
    }, [
        sku,
        salePrice,
        selectedVariantId,
        product,
        quantity,
        cartTotal,
        customerId,
        customerEmail,
        price, 
    ]);
    (0,react.useEffect)(function() {
        var reportViewContentToFacebook = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, salePrice;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!(!sku || !selectedVariant || !product)) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            salePrice = parseFloat("".concat(calculatedPrice).replace(/(^\$|,)/g, ""));
                            Facebook.Facebook.viewContent({
                                user: user,
                                content_ids: [
                                    sku
                                ],
                                content_category: ((ref = (0,_to_consumable_array/* default */.Z)(product.category_info).pop()) === null || ref === void 0 ? void 0 : ref.name) || "",
                                content_name: selectedVariant.name,
                                contents: [
                                    {
                                        id: sku,
                                        quantity: 1,
                                        item_price: salePrice
                                    }
                                ],
                                value: salePrice
                            }).catch(Log/* error */.vU);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function reportViewContentToFacebook() {
                return _ref.apply(this, arguments);
            };
        }();
        reportViewContentToFacebook().catch(Log/* error */.vU);
    }, [
        sku,
        selectedVariant,
        calculatedPrice,
        product,
        user
    ]);
    return null;
};
/* harmony default export */ var hooks_PdpTrackingServices = (PdpTrackingServices);


/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Facebook": function() { return /* binding */ Facebook; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82222);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);









// Pixel is the front-end APi that sends data to Meta, Docs:
// https://developers.facebook.com/docs/meta-pixel/reference
var hashing = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var ref, ref1, sha256;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(typeof data === "string")) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 2023).then(__webpack_require__.t.bind(__webpack_require__, 72023, 23))
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    sha256 = ref1.default.sha256;
                    return _ctx.abrupt("return", sha256(data.trim().toLowerCase()));
                case 9:
                    return _ctx.abrupt("return", null);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function hashing(data) {
        return _ref.apply(this, arguments);
    };
}();
var parseUserData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email, phone) {
        var ref, ref1, Cookies;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 36808, 23))
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    Cookies = ref1.default;
                    _ctx.t2 = Cookies.get("_fbc");
                    _ctx.t3 = Cookies.get("_fbp");
                    _ctx.next = 11;
                    return hashing(email);
                case 11:
                    _ctx.t4 = _ctx.sent;
                    _ctx.next = 14;
                    return hashing(phone);
                case 14:
                    _ctx.t5 = _ctx.sent;
                    _ctx.t6 = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || "";
                    return _ctx.abrupt("return", {
                        fbc: _ctx.t2,
                        fbp: _ctx.t3,
                        em: _ctx.t4,
                        ph: _ctx.t5,
                        client_user_agent: _ctx.t6
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function parseUserData(email, phone) {
        return _ref.apply(this, arguments);
    };
}();
var Pixel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventName) {
        var eventPayload, eventID, ref, ref1, uuidv4, event_id, user, event_time, source_url, userdata, ref2, ref3, Axios, _args = arguments;
        return _codebuild_output_src557632705_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventPayload = _args.length > 1 && _args[1] !== void 0 ? _args[1] : undefined, eventID = (_args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        eventID: ""
                    }).eventID;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("Facebook: Pixel invoked for ".concat(eventName));
                    if (true) {
                        _ctx.next = 5;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("Facebook: error no Window");
                    return _ctx.abrupt("return", {
                        success: false
                    });
                case 5:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 8;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 6578).then(__webpack_require__.bind(__webpack_require__, 46578))
                        ];
                    });
                case 8:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    ref1 = ref[0];
                    uuidv4 = ref1.v4;
                    event_id = eventID || uuidv4();
                    user = (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.user) || null;
                    _ctx.prev = 14;
                    if (eventPayload && user) {
                        delete eventPayload.user;
                    }
                    if (!( true && typeof window.fbq === "function")) {
                        _ctx.next = 22;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("Facebook: Window.FBQ Called");
                    _ctx.next = 20;
                    return window.fbq("track", eventName, eventPayload, {
                        eventID: event_id
                    });
                case 20:
                    _ctx.next = 23;
                    break;
                case 22:
                    {
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Facebook: Either window is not an object or fbq is not a function");
                    }
                case 23:
                    if (!(typeof eventPayload === "object")) {
                        _ctx.next = 39;
                        break;
                    }
                    event_time = Math.floor(Date.now() / 1000);
                    source_url = window.location.href;
                    _ctx.next = 28;
                    return parseUserData(user === null || user === void 0 ? void 0 : user.email, user === null || user === void 0 ? void 0 : user.phone);
                case 28:
                    userdata = _ctx.sent;
                    _ctx.t2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 32;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23))
                        ];
                    });
                case 32:
                    _ctx.t3 = _ctx.sent;
                    ref2 = (0, _ctx.t2)(_ctx.t3, 1);
                    ref3 = ref2[0];
                    Axios = ref3.default;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("Facebook: Conversion API Request Sent", eventPayload);
                    _ctx.next = 39;
                    return Axios.post("".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__.OAUTH_API, "/sf/marketing/facebookEvent/").concat(eventName), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, eventPayload, userdata), {
                        event_time: event_time,
                        source_url: source_url,
                        event_id: event_id
                    }));
                case 39:
                    return _ctx.abrupt("return", {
                        success: true
                    });
                case 42:
                    _ctx.prev = 42;
                    _ctx.t4 = _ctx["catch"](14);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Facebook: Pixel ".concat(eventName, " Failed ").concat(String(_ctx.t4)), _ctx.t4);
                case 45:
                    return _ctx.abrupt("return", {
                        success: false
                    });
                case 46:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                42
            ]
        ]);
    }));
    return function Pixel(eventName) {
        return _ref.apply(this, arguments);
    };
}();
var addToCart = function(param) {
    var content_ids = param.content_ids, content_category = param.content_category, content_name = param.content_name, _content_type = param.content_type, content_type = _content_type === void 0 ? "product" : _content_type, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, contents = param.contents, value = param.value, user = param.user;
    return Pixel("AddToCart", {
        content_ids: content_ids,
        content_category: content_category,
        content_name: content_name,
        content_type: content_type,
        contents: contents,
        currency: currency,
        value: value,
        user: user
    });
};
var viewContent = function(param) {
    var content_ids = param.content_ids, content_category = param.content_category, content_name = param.content_name, _content_type = param.content_type, content_type = _content_type === void 0 ? "product" : _content_type, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, contents = param.contents, value = param.value, user = param.user;
    return Pixel("ViewContent", {
        content_ids: content_ids,
        content_category: content_category,
        content_name: content_name,
        content_type: content_type,
        currency: currency,
        contents: contents,
        value: value,
        user: user
    });
};
var initializeCheckout = function(param) {
    var content_ids = param.content_ids, contents = param.contents, _content_type = param.content_type, content_type = _content_type === void 0 ? "product" : _content_type, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, value = param.value, num_items = param.num_items, user = param.user;
    return Pixel("InitiateCheckout", {
        content_ids: content_ids,
        contents: contents,
        content_type: content_type,
        currency: currency,
        num_items: num_items,
        value: value,
        user: user
    });
};
var trackPurchase = function(param) {
    var content_ids = param.content_ids, order_id = param.order_id, _content_type = param.content_type, content_type = _content_type === void 0 ? "product" : _content_type, contents = param.contents, value = param.value, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, num_items = param.num_items, user = param.user;
    return Pixel("Purchase", {
        content_ids: content_ids,
        order_id: order_id,
        content_type: content_type,
        contents: contents,
        value: value,
        currency: currency,
        num_items: num_items,
        user: user
    }, {
        eventID: order_id
    });
};
var completeRegistration = function(param) {
    var content_name = param.content_name, _status = param.status, status = _status === void 0 ? true : _status, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, user_email = param.user_email;
    return Pixel("CompleteRegistration", {
        content_name: content_name,
        status: status,
        currency: currency,
        user_email: user_email
    });
};
var search = function(param) {
    var search_string = param.search_string, content_ids = param.content_ids, contents = param.contents, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, _value = param.value, value = _value === void 0 ? 0 : _value, user = param.user;
    return Pixel("Search", {
        content_category: "Product Search",
        content_ids: content_ids,
        contents: contents,
        currency: currency,
        search_string: search_string,
        value: value,
        user: user
    });
};
var customizeProduct = function() {
    return Pixel("CustomizeProduct");
};
var pageView = function() {
    return Pixel("PageView");
};
var init = function() {
    try {
        var ref;
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("Facebook: Pixel init typeof fbq = ".concat((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(window.fbq)), {
            FACEBOOK_PIXEL_ID: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FACEBOOK_PIXEL_ID
        });
        (ref = window.fbq) === null || ref === void 0 ? void 0 : ref.call(window, "init", _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FACEBOOK_PIXEL_ID);
        pageView();
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Facebook: Failed to Initialize Facebook Pixel ".concat(String(err)), err);
    }
};
var addToWishlist = function(param) {
    var content_ids = param.content_ids, content_category = param.content_category, content_name = param.content_name, _content_type = param.content_type, content_type = _content_type === void 0 ? "product" : _content_type, _currency = param.currency, currency = _currency === void 0 ? "USD" : _currency, contents = param.contents, value = param.value, user = param.user;
    return Pixel("AddToWishlist", {
        content_ids: content_ids,
        content_category: content_category,
        content_name: content_name,
        content_type: content_type,
        contents: contents,
        currency: currency,
        value: value,
        user: user
    });
};
var Facebook = {
    customizeProduct: customizeProduct,
    search: search,
    completeRegistration: completeRegistration,
    trackPurchase: trackPurchase,
    initializeCheckout: initializeCheckout,
    viewContent: viewContent,
    addToCart: addToCart,
    pageView: pageView,
    init: init,
    hashing: hashing,
    parseUserData: parseUserData,
    addToWishlist: addToWishlist
};
/* harmony default export */ __webpack_exports__["default"] = (Facebook);


/***/ }),

/***/ 65416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ listrakProductBrowse; }
/* harmony export */ });
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27429);

/* eslint-disable no-underscore-dangle */ function listrakProductBrowse(sku) {
    try {
        var ref, ref1;
        var listrak = window === null || window === void 0 ? void 0 : window._ltk;
        listrak === null || listrak === void 0 ? void 0 : (ref = listrak.Activity) === null || ref === void 0 ? void 0 : (ref1 = ref.AddProductBrowse) === null || ref1 === void 0 ? void 0 : ref1.call(ref, sku);
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_0__/* .error */ .vU)("Failed to send browseProduct to listrak", err);
    }
};


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);